<style lang="scss" scoped>
	@import "./supplylist.css";
</style>
<style>
	.grayc {
		color: #cfcfcf !important;
	}

	.greenc {
		/* color: #0c8b97 !important; */
		color: #808080 !important;
	}
</style>
<template>
	<div id="supplylist">
		<div class="topHeader">
			<a-form-model :model="params" style="width:100%;" labelAlign="right" layout="inline">
				<a-row type='flex' justify='space-between'>
					<a-col :xl="{ span: 4 }">
						<a-form-model-item label="信息查詢" class="formItem">
							<a-input v-model="params.searchstr" placeholder="請輸入信息查詢"  :allowClear="true" @change="handleClear(1)"/>
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 5 }">
						<a-form-model-item label="開始時間" class="formItem">
							<a-range-picker :placeholder="['開始時間','結束時間']" format="YYYY/MM/DD" v-model="params.timeDate"
								@change='fanhand'>
							</a-range-picker>
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 5 }">
						<a-form-model-item label="結束時間" class="formItem">
							<a-range-picker :placeholder="['開始時間','結束時間']" format="YYYY/MM/DD"
								v-model="params.timeDates" @change='fanhands'>
							</a-range-picker>
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 4 }">
						<a-form-model-item label="客服姓名" class="formItem">
							<a-input v-model="params.kfname" placeholder="請輸入客服姓名"  :allowClear="true" @change="handleClear(2)"/>
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 3 }">
						<div style="display: inline-flex;align-items: center;">
							<div class="btn_cla" style="background-color:#3bc7a1;margin-right: 1rem;"
								@click="searchEvent">
								<img src="../../image/icon_sousuo.png" class="btnIcon" />
								<span>搜索</span>
							</div>
							<div class="btn_cla" style="background-color:#ffa647;"
								@click="clearEvent">
								<img src="../../image/icon_chongzhi.png" class="btnIcon" />
								<span>重置</span>
							</div>
						</div>
					</a-col>
				</a-row>
			</a-form-model>
		</div>
		<div class="bottomMain">
			<div class="tableBtnView">
				<!-- <div class='btn_list' @click='visible_bold = 2'>
					<img src="../../image/subscr/mes.png" class="btnIcon" />
					<span style="color:#3bc7a1;">對話</span>
				</div> -->
				<div class='btn_list' @click='visible_bold = 1'>
					<img src="../../image/emp1.png" class="btnIcon" />
					<span style="color: #ffa647;">添加問題話術</span>
				</div>
				<!-- 	<a-upload name="file" :data='{token:$store.state.token,flag:"systemservice"}' :headers='{token:$store.state.token}'
					class="avatar-uploader" :show-upload-list="false" :action="$api.newOtherExcelAdd"
					:before-upload="beforeUpload" @change="handleChange" v-if=' acontractinsert'> -->
				<!-- <div class='btn_list' >
						<img src="../../image/endexs.png" class="btnIcon" />
						<span style="color:rgb(93, 176, 234);">導入</span>
					</div> -->
				<!-- </a-upload> -->

				<task :params='params' @child='fandfn'></task>
			</div>
			<a-table style="width:100%;" :columns="columns" :data-source="columnsData" id='fromtable'
				:rowKey='(record, index) => index' :customRow='rowstely'
				:row-selection="{ selectedRowKeys: selectedRows, onChange: onSelectChange }" :pagination="false"
				:bordered="true">
				<span slot='alltext' style="font-size: 0.85rem;position: relative;text-align: center;">客戶名稱
					<!-- <span style="font-size: 0.85rem;position: relative;left: -9rem;"></span> -->
				</span>
				<div slot='name' slot-scope='record' style="text-align: center;padding-left: -2.5rem ;">
					{{record.username}}
				</div>
				<div slot='phonenum' slot-scope='record'>
					<!-- margin-left: 2rem ;text-align: left; -->
					{{record.phonenum}}
				</div>
				<div slot='status' slot-scope="record" style="white-space: nowrap;">
					<div v-if='record.status == "已過期"'>{{record.status}}</div>
					<div v-else-if='record.status == "正常"' style='color: #3bc7a1;'>{{record.status}}</div>
					<div v-else style='color: #ee5253;'>{{record.status}}</div>
				</div>
				<span slot='regdate' @click='uploadfn("up",1)' style="cursor: pointer;">
					開始時間
					<!-- <div style="display: inline-block;position: relative;top: -1rem;">
						<a-icon type="caret-up" :class='params.register_date_sort!=="up"?"grayc":"greenc"' 
						style='position: absolute;top: 0;'/>
						<a-icon type="caret-down" :class='params.register_date_sort!=="down"?"grayc":"greenc"'
						 style='position: absolute;top: .6rem;'/>
					</div> -->
				</span>
				<span slot='expire_date' @click='uploadfn("up")' style="cursor: pointer;">
					結束時間
					<!-- <div style="display: inline-block;position: relative;top: -1rem;">
						<a-icon type="caret-up" :class='params.expire_date_sort!=="up"?"grayc":"greenc"'
						style='position: absolute;top: 0;'/>
						<a-icon type="caret-down" :class='params.expire_date_sort!=="down"?"grayc":"greenc"'
						 style='position: absolute;top: .6rem;'/>
					</div> -->
				</span>

				<!-- 控制按鈕 -->
				<div slot="toolArr" slot-scope="record">
					<div class="tableRowView2">
						<div v-if='record.selftalk == 1'>
							   <a-badge :count="record.noreadnum">
								   <img :src="require('@/image/liaotian.png')"
								   class="imageb" @click='handediot(record,2)'>
							    </a-badge>
						</div>
						<div v-else>
							<img :src="record.moreShowBol !== 2?require('../../image/lea/chakan1.png'):require('../../image/lea/chakan.png')"
								class="imageb" 
								@click='handediot(record,4)'>
								<!-- :style="{opacity:record.status == '已過期'?'.5':'1'}" -->
						</div>
					</div>
				</div>
			</a-table>
			<div class="paginationView">
				<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
				<div style="margin-left:auto;">
					<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
						:pageSize="params.perPage" />
				</div>
				<div class="pageTzView">
					<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
					<span @click="tzEvent">跳轉</span>
				</div>
			</div>
		</div>
		<handItem v-if='visible_bold==1' @child='handclose' :items='isdate'></handItem>
		<handItems v-if='visible_bold==2' @child='handclose' :items='isdate' ref='visible_bold2' @childval='childvalfn'>
		</handItems>
		<handcaozuo v-if='visible_bold==3' @child='handclose' :items='isdate'></handcaozuo>
		<!-- <liaotianjilu  v-if='visible_bold==4' @child='handclose' :items='isdate'></liaotianjilu> -->
		<liaotianjilu1 v-if='visible_bold==4' @child='handclose' :items='isdate'></liaotianjilu1>
		<!-- 搜索无结果弹窗 -->
		<div>
            <a-modal  id='handout' width='25rem' v-model="ishandout" on-ok="handleOk1" v-dragModal :dialog-style='{top:"30vh"}'  @cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
                <div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
                    <div style="border-radius:0;width: 23rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;left: -0.5rem;">
                        提 示
                    </div>
                </div>
                <div solt='title' style="position: relative;"></div>
                <div style='margin-top: 3rem;height: 3rem;font-size:.8rem;line-height:3rem;display: flex;align-items: center;'>
                    <a-icon type="exclamation-circle" style='font-size: 1.2rem;color: orange;margin-right:.5rem;'/>	搜索內容不存在
                </div>
                <div style="text-align: right">
                    <button class='btn-main btn-main1' @click='ishandout = false'>取 消</button>
                    <button class='btn-main' @click='ishandout = false'>確 認</button>
                </div>
            </a-modal>
        </div>
	</div>
	
</template>
<script>
	import App from '@/assets/app.js';
	import handItem from './components/handItem'
	import handItems from './components/handItems'
	import handcaozuo from './components/handcaozuo'
	import liaotianjilu from './components/liaotianjilu'
	import liaotianjilu1 from './components/liaotianjilu1'
	import task from './components/task.vue'
	import VueSocketIO from 'vue-socket.io';
	import Vue from 'vue'
	import urlapi from '@/assets/api.js'
	//socket
	Vue.use(new VueSocketIO({
		// debug: true,
		// connection: 'https://hk.qmisit.com:6609'
		connection: urlapi.connection,
		// connection: 'http://202.130.113.149:9060',
		// connection:'http://192.168.31.93:6609'
	}));

	export default {
		components: {
			handItem,
			task,
			handItems,
			handcaozuo,
			liaotianjilu,
			liaotianjilu1
		},
		
		data() {
			return {
				ishandout:false,
				datalist: [],
				isdate: '',
				visible_bold: '',
				//系統服務新增管理  acontractinsert
				//系統服務編輯管理  acontractedit
				acontractinsert: this.$store.state.rolesdata.indexOf('acontractinsert') >= 0,
				acontractedit: this.$store.state.rolesdata.indexOf('acontractedit') >= 0,
				tzPageNum: '',
				columns: [{
						// title: '',
						dataIndex: '',
						align: 'center',
						width: '15%',
						scopedSlots: {
							customRender: 'name'
						},
						slots: {
							title: 'alltext'
						}
					},
					{
						title: '客戶電話 / 證券帳號',
						dataIndex: '',
						align: 'center',
						width: '10%',
						scopedSlots: {
							customRender: 'phonenum'
						},
					},
					{
						title: '國家/地區',
						dataIndex: 'addrname',
						align: 'center',
						width: '13%'
					},
					{
						title: '客戶郵箱',
						dataIndex: 'email',
						align: 'center',
						width: '13%'
					},
					{
						// title: '開始日期',
						dataIndex: 'begintime',
						align: 'center',
						width: '13%',
						slots: {
							title: 'regdate'
						}
					},
					{
						// title: '結束日期',
						dataIndex: 'endtime',
						align: 'center',
						width: '13%',
						slots: {
							title: 'expire_date'
						}
					},
					{
						title: '客服姓名',
						dataIndex: 'kfname',
						align: 'center',
						width: '13%',
					},
					{
						title: '操作',
						dataIndex: '',
						align: 'center',
						width: 'auto',
						scopedSlots: {
							customRender: 'toolArr'
						}
					},
				],
				columnsData: [],
				selectedRows: [], //checkbox
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					perPage: 10, //每頁條目數
					missionflag: 0, //任務中  1
					timeDate: [],
					timeDates: [],
					begintime_begin: '',
					begintime_end: '',
					endtime_begin: '',
					endtime_end: '',
					searchstr: '',
					kfname: '',
				}
			}
		},
		created() {},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * 10;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum * 10;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},
		},
		mounted() {
			this.messLoad();
			this.$socket.connect()
		},
		methods: {
			handleCancel(ev){
                this.ishandout = false
			},
			handleClear(val){
				if (val == 1 ) {
					if (!this.params.searchstr) {
						this.messLoad()
					}
				}
				if (val == 2 ) {
					if (!this.params.kfname) {
						this.messLoad()
					}
				}
            },
			childvalfn(obj) {
				var _this = this;
				_this.$socket.emit("kfmessage",obj);
			},
			disabledStartDate(startValue) {
				if (this.params.timeDate1[1]) {
					const endValue = this.params.timeDate1[1];
					if (!startValue || !endValue) {
						return false;
					}
					return startValue.valueOf() < endValue.valueOf();
				}
			},
			fanhand(val) {
				this.params.begintime_begin = this.params.timeDate[0] ? App.oDate.secsTime3(this.params.timeDate[0]
						._d) : '',
					//認購截止日期
					this.params.begintime_end = this.params.timeDate[1] ? App.oDate.secsTime3(this.params.timeDate[1]
						._d) : ''
			},
			fanhands(val) {
				this.params.endtime_begin = this.params.timeDates[0] ? App.oDate.secsTime3(this.params.timeDates[0]
						._d) : '',
					//認購截止日期
					this.params.endtime_end = this.params.timeDates[1] ? App.oDate.secsTime3(this.params.timeDates[1]
						._d) : ''
			},
			pdfEvent() {

			},
			rowstely(record, index) {
				if(record.isonline!== 1){
					if (record.selftalk !== 1) {
					return {
						style: {
							'color': '#999',
							opacity: '.5'
						},
					}
					}
				}
			},
			uploadfn(val, a) {
				if (a) {
					if (this.params.register_date_sort == 'up') {
						this.params.register_date_sort = 'down'
					} else if (this.params.register_date_sort == 'down') {
						this.params.register_date_sort = ''
					} else if (this.params.register_date_sort == '') {
						this.params.register_date_sort = 'up'
					}
				} else {
					if (this.params.expire_date_sort == 'up') {
						this.params.expire_date_sort = 'down'
					} else if (this.params.expire_date_sort == 'down') {
						this.params.expire_date_sort = ''
					} else if (this.params.expire_date_sort == '') {
						this.params.expire_date_sort = 'up'
					}
				}
				this.messLoad();
			},
			
			handediot(val, a) {
				if(a==2){
					this.$ajax({
						method:'post',
						url:this.$api.startNewTalk,
						data:{
							"roomid":val.roomid
						}
					}).then(res=>{})
				}
				setTimeout(()=>{
					this.isdate = val
					this.visible_bold = a;
					if (a == 1) {
						val.visible_bold = a
					} else {
						val.moreShowBol = a
					}
				},200)
			},
			handleChange(info) {
				if (info.file.response) {
					if (info.file.response.qmiscode == 1000) {
						this.loading = true;
						this.$message.success('導入成功');
						this.messLoad();
					} else {
						this.loading = false;
						this.$message.error(info.file.response.qmismsg);
					}
				}
			},
			beforeUpload(file) {
				var fileFormat = file.name
					.substring(file.name.lastIndexOf("."))
					.toLowerCase();
				const isJpgOrPng = fileFormat.match(/.xls|.xlsx/);
				if (!isJpgOrPng) {
					this.$message.error('只能上傳xls或xlsx文件!');
				}
				return isJpgOrPng;
			},
			fandfn(val) {
				if (val == 'back') {
					this.params.missionflag = 0
					this.params.flag = ''
				} else {
					this.params.missionflag = 1
					this.params.flag = val 
				}
				this.messLoad()
			},
			handopen() {
				window.location.href = this.$api.getExcel + '?token=' + this.$store.state.token
			},
			onSelectChange(selectedRowKeys) {
				this.selectedRows = selectedRowKeys;
			},
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			handland(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.getParamList,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"type": val
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {

					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			handclose(val) {
				this.isdate = ''
				this.visible_bold = '';
				this.columnsData.map(ev => {
					for (let key in ev) {
						ev['visible_bold'] = ''
						ev['moreShowBol'] = ''
					}
				})
					this.messLoad();
			},
			messLoad() {
				this.selectedRows = []
				this.$ajax({
					method: 'post',
					url: this.$api.TalkOnline,
					headers: {
						token: this.$store.state.token,
						// elftalk:'',//1 聊天窗口  0 歷史記錄
					},
					data: this.params
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.columnsData = res.data.talkOnlineUsersList
						this.columnsData.map(ev => {
							for (let key in ev) {
								ev['visible_bold'] = ''
								ev['moreShowBol'] = ''
							}
						})
						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
						this.params.missionnum = res.data.missionnum
						if (this.params.searchstr || this.params.begintime_begin || this.params.endtime_begin || this.params.kfname) {
							if (this.columnsData.length<=0) {
								this.ishandout = true
							}
						}
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					App.oTool.warningT(err.data.qmismsg);
				});
			},
			searchEvent() {
				this.params.pageNum = 1;
				this.messLoad();
			},

			clearEvent() {
				this.params = {}
				this.params = {
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					perPage: 10, //每頁條目數
					missionflag: 0, //任務中  1
					timeDate: [],
					timeDates: [],
					begintime_begin: '',
					begintime_end: '',
					endtime_begin: '',
					endtime_end: '',
					searchstr: '',
					kfname: '',
				}
				this.messLoad();
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.messLoad();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.messLoad();
			},
		},
		sockets: {
			disconnect: function() {
			},
			//新增對話
			newtalk: function(data) {
				this.messLoad();
				if (this.visible_bold == 2) {
					this.$refs['visible_bold2'].getshua(data)
				}
			},
			closeroomwindow: function(data) {
				// console.log('-----------',data,'-------',this.isdate.roomid,66)
				if(this.isdate.roomid==data.roomid){
					this.handclose()
				}
			},
			//回复的消息
			newusermsg: function(data) {
				this.messLoad();
				if (this.visible_bold == 2) {
					this.$refs['visible_bold2'].getshua(data)
				}
			},
			connect: function() {
				//这里是监听connect事件
				this.$socket.emit("init", {
					usertype: "kf",
					token: this.$store.state.token,
				}, val => {
					if (val === 'success') {
						this.$message.success('success')
						//设置心跳包
						// this.timer = setInterval(this.setOnline, 4000);
						// this.dialogTableVisible = false;
					} else {
						this.$message.warning(val)
						this.$router.push({
							path: '/'
						});
					}
				});
			},
			reconnect: function() {
				//这里是监听connect事件
				this.$socket.emit("init", {
					usertype: "kf",
					token: this.$store.state.token,
				}, val => {
					if (val === 'success') {
						this.$message.success('success')
						//设置心跳包
						// this.timer = setInterval(this.setOnline, 4000);
						// this.dialogTableVisible = false;
					} else {
						this.$message.warning(val)
						// this.$router.push({path: '/'});
					}
				});
			},
		},
		onbeforeunload: {
			disconnect: function() {
				//这里是监听connect事件
			},
		},
		beforeDestroy() {
			// this.disconnect()
			this.$socket.close()
			// this.$socket.on('disconnect', () => {
			// 		console.log('客户端断开')
			// 	})
		},
	};
</script>
